module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAAA2BAMAAAB6nqfTAAAAG1BMVEW8vLwAAACNjY1eXl51dXUvLy+kpKRGRkYXFxdjdNnOAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAn0lEQVQ4je2OPwuCQBxAH9ofx65IHHMIGo/AWqXoA1iD69mQN9ogNIdBH7s7B7W9tnvTg8fvDzgcPycWCy9rvDk6NQqvPp1uqkjjVU1tFX/Zpz2sCdJgG1plk/Tp8ZZQKC+SrZ4H6Xht4AJZq341SJAwrhiZKaNaDdLOpBz0IbR6F2LWpXzSTCuwHxq1OzrKSMZCPEO0LO3Sr1sOx//5AM+PGsv0uEepAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon01.png
// module id = zhR6
// module chunks = 0